import styled from "styled-components";

export const DealPageWrapper = styled.div<{ isWhiteBackground: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  gap: 16px;
  background: ${({ theme, isWhiteBackground }) =>
    isWhiteBackground
      ? theme.colors.ui.background.raised
      : theme.colors.ui.background.page};
`;

export const DealListPage = styled.div<{ paddingBottom?: string }>`
  display: flex;
  flex-direction: column;
  padding-bottom: ${({ paddingBottom }) => paddingBottom || "24px"};
`;

export const DealCardsWrapper = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const DealCardClickArea = styled.div`
  cursor: pointer;
`;

export const CurrencyDropDownWrapper = styled.div`
  width: fit-content;
`;

export const StatusDropDownWrapper = styled.div`
  width: fit-content;
`;

export const FilterWrappers = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;
